import React, { useState, useEffect } from "react";
import { useGeld } from "../context/GeldContext";

const GeldTracker = () => {
  const { geldBalance } = useGeld();
  const [isAnimating, setIsAnimating] = useState(false);
  const [prevBalance, setPrevBalance] = useState(geldBalance);

  // Animate when geld balance changes
  useEffect(() => {
    if (geldBalance !== prevBalance) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 500);
      setPrevBalance(geldBalance);
      return () => clearTimeout(timer);
    }
  }, [geldBalance, prevBalance]);

  return (
    <div
      className="geld-tracker"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
        backgroundColor: "#f3e1b2",
        borderRadius: "12px",
        padding: "6px 12px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        fontFamily: "'Inter', sans-serif",
        fontWeight: "600",
        fontSize: "16px",
        color: "#000",
        transition: "transform 0.2s ease",
        transform: isAnimating ? "scale(1.1)" : "scale(1)",
        WebkitUserSelect: "none",
        MsUserSelect: "none",
        userSelect: "none",
      }}
    >
      <div
        className="geld-icon"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "4px",
        }}
      >
        <img
          src="/geld.png"
          alt="geld"
          style={{
            width: "18px",
            height: "18px",
            objectFit: "contain",
            verticalAlign: "middle",
          }}
        />
      </div>
      <span 
        className="geld-amount" 
        style={{
          WebkitUserSelect: "none",
          MsUserSelect: "none",
          userSelect: "none",
        }}
      >
        {geldBalance}
      </span>
    </div>
  );
};

export default GeldTracker;
